import axios from 'axios'
import router from '../router'; 
import { Message, MessageBox } from 'element-ui'

const http = axios.create({
	baseURL: process.env.VUE_APP_BASE_API,
	timeout: 1000 * 30
})

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
	let accessToken = sessionStorage.getItem("accessToken");
	if (accessToken) {
		config.headers.accessToken = encodeURIComponent(accessToken);
        config.headers.clientTime=new Date().getTime();
	}
	return config
}, error => {
	return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(async response => {
	if (response.data.code == 200) {
		return response.data.data;
	} else if (response.data.code == 400) {
		//MessageBox.alert('接口: ' + response.config.url + '\n响应: ' + JSON.stringify(response.data), '[PATH-4] HTTP响应code=400触发退出');
		return exit();
	} else if (response.data.code == 401) {
		console.log("token失效，尝试重新获取")
		let refreshToken = sessionStorage.getItem("refreshToken");
		if (!refreshToken) {
			MessageBox.alert('accessToken失效且无refreshToken\n接口: ' + response.config.url, '[PATH-3A] 无refreshToken触发退出');
			return exit()
		}
		// 发送请求, 进行刷新token操作, 获取新的token
		const data = await http({
			method: 'put',
			url: '/refreshToken',
			headers: {
				refreshToken: refreshToken
			}
		}).catch((err) => {
			MessageBox.alert('refreshToken刷新失败\n错误: ' + (err && err.message || err || '未知错误'), '[PATH-3B] Token刷新失败触发退出');
			exit();
			return null;
		})
		// fix #117: 守卫 data undefined 避免 'Cannot read properties of undefined' 崩溃
		if (!data) {
			return Promise.reject(new Error('refreshToken failed'));
		}
		// 保存token
		sessionStorage.setItem("accessToken", data.accessToken);
		sessionStorage.setItem("refreshToken", data.refreshToken);
		// 重新发送刚才的请求
		return http(response.config)
	} else {
		Message({
			message: response.data.message,
			type: 'error',
			duration: 1500,
			customClass: 'element-error-message-zindex'
		})
		return Promise.reject(response.data)
	}
}, error => {
	if (!error.response) {
		Message({
			message: '网络连接异常，请检查网络后重试',
			type: 'error',
			duration: 3000,
			customClass: 'element-error-message-zindex'
		})
		return Promise.reject(error)
	}
	switch (error.response.status) {
		case 400:
			Message({
				message: error.response.data,
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
		case 401:
			MessageBox.alert('HTTP状态码401\n接口: ' + error.config.url, '[PATH-3C] HTTP 401错误触发退出');
			exit();
			break
		case 405:
			Message({
				message: 'http请求方式有误',
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
		case 404:
		case 500:
			Message({
				message: '服务器出了点小差，请稍后再试',
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
		case 501:
			Message({
				message: '服务器不支持当前请求所需要的某个功能',
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
	}

	return Promise.reject(error)
})



const exit = () => {
	router.app.$eventBus.$emit("exit")
}


export default http
